(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-switcher"] && !Shopify.designMode) return;
  try {
    
  class CategorySwitcher extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-category-switcher-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-category-switcher-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.showTab(tab.dataset.categorySwitcherTab));
      });
    }

    showTab(activeTab) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.categorySwitcherTab === activeTab;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.categorySwitcherPanel === activeTab;

        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

    }
  }

  if (!customElements.get('category-switcher')) {
    customElements.define('category-switcher', CategorySwitcher);
  }

  } catch(e) { console.error(e); }
})();
})();
